import { Suspense, lazy } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, CampaignFinancesGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
const FinancesPage = lazy(() => import('src/pages/finances'));
const ContributionAddPage = lazy(() => import('src/pages/finances/contribution-add'));
const ContributionEditPage = lazy(() => import('src/pages/finances/contribution-edit'));
const DonorsPage = lazy(() => import('src/pages/finances/donors'));
const ExpenditureAddPage = lazy(() => import('src/pages/finances/expenditure-add'));
const ExpenditureEditPage = lazy(() => import('src/pages/finances/expenditure-edit'));
const VendorsPage = lazy(() => import('src/pages/finances/vendors'));
const DonorViewPage = lazy(() => import('src/pages/finances/donor-view'));
const VendorViewPage = lazy(() => import('src/pages/finances/vendor-view'));

export const financeRoutes = [
  {
    path: 'finances',
    element: (
      <AuthGuard>
        <CampaignFinancesGuard>
          <DashboardLayout>
            <Suspense fallback={<LoadingScreen />}>
              <Outlet />
            </Suspense>
          </DashboardLayout>
        </CampaignFinancesGuard>
      </AuthGuard>
    ),
    children: [
      { element: <FinancesPage />, index: true },
      { path: ':orgId', element: <FinancesPage />, index: true },
      {
        path: ':orgId/contribution/create',
        element: <ContributionAddPage />,
      },
      {
        path: ':orgId/contribution/:transactionId/edit',
        element: <ContributionEditPage />,
      },

      {
        path: ':orgId/expenditure/create',
        element: <ExpenditureAddPage />,
      },
      {
        path: ':orgId/expenditure/:transactionId/edit',
        element: <ExpenditureEditPage />,
      },
      {
        path: 'donors',
        element: <DonorsPage />,
      },
      {
        path: 'vendors',
        element: <VendorsPage />,
      },
      {
        path: 'donors/:donorId',
        element: <DonorViewPage />,
      },
      {
        path: 'vendors/:vendorId',
        element: <VendorViewPage />,
      },
    ],
  },
];
